// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as HeaderVm$PorterinFeature from "../vm/HeaderVm.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as AuthStore$PorterinFeature from "../../../../containers/login/domain/store/AuthStore.mjs";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as OrderReviewHelper$PorterinFeature from "../../../../containers/order-review/domain/helpers/OrderReviewHelper.mjs";
import * as LinkTrackOrdersModuleScss from "../styles/LinkTrackOrders.module.scss";

var styles = LinkTrackOrdersModuleScss;

function LinkTrackOrdersCmp(Props) {
  var count_of_ongoing_order = Props.count_of_ongoing_order;
  var order_crn = Props.order_crn;
  var is_courier_order = Props.is_courier_order;
  if (count_of_ongoing_order !== 0) {
    return React.createElement("div", {
                className: styles["track-orders-container"],
                onClick: (function (param) {
                    var match = count_of_ongoing_order > 1;
                    if (match) {
                      return JsBindings$PorterinUtils.redirect(Config$PorterinUtils.oms_url + ("/" + OrderReviewHelper$PorterinFeature.getLocaleCookie(undefined) + "/order-history"));
                    } else if (is_courier_order) {
                      return OrderReviewHelper$PorterinFeature.courierTrackingLinkRedirect(order_crn);
                    } else {
                      return OrderReviewHelper$PorterinFeature.allocationLinkRedirect(order_crn);
                    }
                  })
              }, React.createElement("div", {
                    className: styles["text-wrapper"]
                  }, React.createElement("p", {
                        className: styles.text
                      }, AuthStore$PorterinFeature.track_order), React.createElement("div", {
                        className: styles["live-orders"]
                      }, React.createElement("div", {
                            className: styles.dot
                          }), AuthStore$PorterinFeature.track_order_live)), React.createElement("div", {
                    className: styles.icon
                  }, React.createElement(NextImage$PorterinFeature.make, {
                        src: HeaderVm$PorterinFeature.right_arrow.src,
                        height: HeaderVm$PorterinFeature.right_arrow.height,
                        width: HeaderVm$PorterinFeature.right_arrow.width,
                        alt: HeaderVm$PorterinFeature.right_arrow.alt
                      })));
  } else {
    return null;
  }
}

var make = LinkTrackOrdersCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
